import React, { useEffect, useState } from "react";
import "../assets/EtablissementHeader.scss";
import LoadPic from "../assets/images/blue-loading-gif-transparent.gif";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToFavorites } from "../store/slices/favorisSlice";
import { useSelector } from "react-redux";

const EtablissementHeader = ({
  etablissement,
  status,
  inscrit = true,
  from,
}) => {

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // Remplace idF pour une meilleure sémantique
  const [isFavorited, setIsFavorited] = useState(status!=="loading" && etablissement?.is_favorited);

  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.user);
  useEffect(() => {
    if (etablissement?.is_favorited !== undefined) {
      setIsFavorited(etablissement.is_favorited);
    }
  }, [etablissement?.is_favorited]);
  if (status === "loading") {
    // Skeleton Loading State
    return (
      <div className="etablissement-header mt-24">
        <div className="return-link">
          <Skeleton width="150px" height="20px" />
        </div>
        <h2 className="etablissement-name">
          <Skeleton width="60%" height={30} />
        </h2>
        <div className="etablissement-info">
          <div className="details-left flex-wrap d-flex">
            <Skeleton width="100px" height={20} />
            <Skeleton width="200px" height={20} />
            <Skeleton width="150px" height={20} />
          </div>
          <div className="service-badges mt-8">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="service-badge">
                <Skeleton width="120px" height={30} />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const handleAddToFavorites = async (id) => {
    if (isLoading) return; // Empêcher les clics multiples

    setIsLoading(true);
    try {
      const resultAction = await dispatch(addToFavorites(id));
      // Mettre à jour l'état seulement après confirmation de Redux
      if (addToFavorites.fulfilled.match(resultAction)) {
        setIsFavorited(!isFavorited);
      }
    } catch (error) {
      // console.error("Erreur inattendue :", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Render State
  if (status !== "loading" && etablissement) {
    return (
      <div className="col-12">
        <div className="etablissement-header mt-32">
          {from !== "inscription" ? (
            <div className="return-link ">
              <div
                onClick={() => navigate("/resultats")}
                className="pointer body grey66 d-flex align-items-center"
              >
                <img
                  className="mr-8"
                  src="../../images/return.svg"
                  alt="return icon"
                />{" "}
                Retour à la recherche
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="d-flex align-items-center justify-content-between">
            <h2 className="etablissement-name break-all mb-0 mt-24">
              {etablissement?.nom}
              {etablissement?.immediat === 1 ? (
                <img
                  src="/images/conf-imm.svg"
                  className="ml-8"
                  alt="icon lock"
                />
              ) : (
                ""
              )}
            </h2>

            {isAuthenticated && inscrit && (
              <div
                className="d-flex align-items-center link-blue"
                onClick={() => handleAddToFavorites(etablissement?.id)}
              >
                {isLoading ? (
                  <img src={LoadPic} className="icon-button" alt="Chargement" />
                ) : isFavorited ? (
                  <>
                    <img
                      src="/images/favorisHeart.svg"
                      className="icon-button"
                      alt="Favori"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src="/images/heart.svg"
                      alt="Coeur"
                      className="heart-icon"
                    />
                    <span className="ml-2">Enregistrer</span>
                  </>
                )}
              </div>
            )}
          </div>

          <div className="etablissement-info ">
            <div className="details-left flex-wrap d-flex">
              <span className="activite d-flex align-items-center">
                {etablissement?.activite?.name}
                <span className="ellipse mx-8"></span>{" "}
              </span>

              <span
                className={`${
                  inscrit ? "adresse" : "body grey66"
                } d-flex align-items-center pointer`}
                onClick={() =>
                  window.open(
                    `https://www.google.com/maps?q=${etablissement.lat},${etablissement.lng}`,
                    "_blank"
                  )
                }
              >
                {etablissement?.adresse_postale ?`${etablissement?.adresse_postale}, ${etablissement?.code_postal} ${etablissement?.ville}`:''}
                {inscrit ? <span className="ellipse mx-8"></span> : ""}
              </span>
              {inscrit ? (
                <>
                  <span className="reviews d-flex align-items-center">
                    <img
                      src="/images/star-02.svg"
                      className="mr-8"
                      alt="star icon"
                    />
                    {/* 4,7 ({Math.floor(Math.random() * 100)} Avis){" "} */}
                    {etablissement?.average_rating} (
                    {etablissement?.reviews_count} Avis){" "}
                  </span>
                </>
              ) : (
                ""
              )}
            </div>
            <div className="service-badges mt-8">
              {etablissement?.lieu_intervention?.map((lieu, index) => {
                return (
                  <React.Fragment key={index}>
                    {lieu === "enligne" && (
                      <div className="service-badge">
                        <img src="/images/enligne.svg" alt="En ligne" /> En
                        ligne
                      </div>
                    )}
                    {lieu === "onsite" && (
                      <div className="service-badge">
                        <img src="/images/domicile.svg" alt="Domicile" /> À
                        domicile
                      </div>
                    )}
                    {lieu === "chezpro" && (
                      <div className="service-badge">
                        <img src="/images/chezpro.svg" alt="Chez Pro" /> Chez le
                        Professionnel
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default EtablissementHeader;
